module.exports = __webpack_public_path__ + "static/img/图片4.64c29f4f.jpg";